module.exports = __webpack_public_path__ + "static/media/Periscope.940d8273.svg";